import { Account, AccountStatus } from '@percent/domain/iam'

const mockRole: Account['role'] = {
  id: 'role-1',
  name: 'Admin',
}

export const mockAccountsData = {
  data: [
    {
      id: 'staging_account_000000D4vW7DAfLKpIumF2KEDuA6K',
      email: 'test1@example.com',
      fullName: 'John Doe',
      role: mockRole,
      status: AccountStatus.active,
      partnerId: 'staging_partner_000000D4vW7DAfLKpIumF2KEDuA6K',
      admin: '2025-01-01T00:00:00Z',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
    {
      id: 'staging_account_000000E5xX8EBgMLqJvnG3LFEuB7L',
      email: 'test2@example.com',
      fullName: 'Jane Smith',
      role: mockRole,
      status: AccountStatus.active,
      partnerId: 'staging_partner_000000E5xX8EBgMLqJvnG3LFEuB7L',
      twoFaSecretVerifiedAt: '2025-01-02T00:00:00Z',
      admin: null,
      createdAt: '2025-01-02T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
    },
    {
      id: 'staging_account_000000E5xX8EBgMLqJvnG3LFEuB7S',
      email: 'invited@example.com',
      fullName: 'Invited User',
      role: mockRole,
      status: AccountStatus.pending,
      partnerId: 'staging_partner_000000E5xX8EBgMLqJvnG3LFEuB7L',
      twoFaSecretVerifiedAt: '2025-01-02T00:00:00Z',
      admin: null,
      createdAt: '2025-01-02T00:00:00Z',
      updatedAt: '2025-01-02T00:00:00Z',
    },
    {
      id: 'staging_account_000000F6yY9FChNRrKwoH4MGFvC8M',
      email: 'deleted@example.com',
      fullName: 'Deleted User',
      role: mockRole,
      status: AccountStatus.removed,
      deletedAt: '2025-01-03T00:00:00Z',
      admin: null,
      createdAt: '2025-01-03T00:00:00Z',
      updatedAt: '2025-01-03T00:00:00Z',
    },
    {
      id: 'staging_account_000000D4vW7DAfLKpIumF2KEDuA6P',
      email: 'admin-tfa@example.com',
      fullName: 'Admin 2FA Verified',
      role: mockRole,
      status: AccountStatus.active,
      twoFaSecretVerifiedAt: '2025-01-02T00:00:00Z',
      partnerId: 'staging_partner_000000D4vW7DAfLKpIumF2KEDuA6L',
      admin: '2025-01-01T00:00:00Z',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
    },
  ],
  totalResults: 3,
  nextPage: null,
  previousPage: null,
}

export const mockAccountsEmptyData = {
  data: [],
  totalResults: 0,
  nextPage: null,
  previousPage: null,
}

export const mockAccountsLargeData = {
  ...mockAccountsData,
  totalResults: 150,
  nextPage: 'next-page-cursor',
}

export const mockAccounts: Account[] = [
  {
    id: 'staging_account_000000D4vW7DAfLKpIumF2KEDuA6K',
    email: 'test1@example.com',
    fullName: 'John Doe',
    role: mockRole,
    status: AccountStatus.active,
    partnerId: 'staging_partner_000000D4vW7DAfLKpIumF2KEDuA6K',
    admin: '2025-01-01T00:00:00Z',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'staging_account_000000E5xX8EBgMLqJvnG3LFEuB7L',
    email: 'test2@example.com',
    fullName: 'Jane Smith',
    role: mockRole,
    status: AccountStatus.active,
    partnerId: 'staging_partner_000000E5xX8EBgMLqJvnG3LFEuB7L',
    twoFaSecretVerifiedAt: '2025-01-02T00:00:00Z',
    admin: null,
    createdAt: '2025-01-02T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
  },
  {
    id: 'staging_account_000000E5xX8EBgMLqJvnG3LFEuB7S',
    email: 'invited@example.com',
    fullName: 'Invited User',
    role: mockRole,
    status: AccountStatus.pending,
    partnerId: 'staging_partner_000000E5xX8EBgMLqJvnG3LFEuB7L',
    admin: null,
    createdAt: '2025-01-02T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
  },
  {
    id: 'staging_account_000000F6yY9FChNRrKwoH4MGFvC8M',
    email: 'deleted@example.com',
    fullName: 'Deleted User',
    role: mockRole,
    status: AccountStatus.removed,
    partnerId: 'staging_partner_000000E5xX8EBgMLqJvnG3LFEuB7L',
    deletedAt: '2025-01-03T00:00:00Z',
    admin: null,
    createdAt: '2025-01-03T00:00:00Z',
    updatedAt: '2025-01-03T00:00:00Z',
  },
]

export const mockAccountsWithNullValues: Account[] = [
  {
    id: 'staging_account_000000D4vW7DAfLKpIumF2KEDuA6K',
    email: 'test1@example.com',
    fullName: null,
    role: null,
    status: AccountStatus.active,
    admin: null,
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'staging_account_000000E5xX8EBgMLqJvnG3LFEuB7L',
    email: 'test2@example.com',
    fullName: 'Jane Smith',
    role: {
      ...mockRole,
      name: null as unknown as string,
    },
    status: AccountStatus.active,
    admin: null,
    createdAt: '2025-01-02T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
  },
]
